import { render, staticRenderFns } from "./AboutMembersIntro.vue?vue&type=template&id=3ccd9e80&"
import script from "./AboutMembersIntro.vue?vue&type=script&lang=js&"
export * from "./AboutMembersIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports